import Badge from 'src/components/badge';

type Props = {
  className?: string;
  roles: string[];
}

export default function Roles({
  className,
  roles = [],
}: Props): JSX.Element {
  if (roles.length === 0) return null;

  return (
    <span className={className} title={roles.join(', ')}>
      {roles.map(role => <Badge key={role}>{role}</Badge>)}
    </span>
  );
}
